import { Box, Button, Center, Flex, HStack, IconButton, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spacer, Table, TableContainer, Tbody, Td, Th, Thead, Tooltip, Tr, useDisclosure } from '@chakra-ui/react'
import { useTable, useGlobalFilter } from 'react-table';
import * as locales from 'react-date-range/dist/locale';
import { useEffect, useMemo, useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';

// Icons
import { BsCalendar3, BsSendArrowUp } from "react-icons/bs";
import { IoCalendarOutline } from "react-icons/io5";
import { RiHistoryLine } from "react-icons/ri";
import { WiDayCloudy } from "react-icons/wi";
import { FiDownload } from "react-icons/fi";

// Components
import ExportDataRange from '../../Components/Export/ExportDataRange';
import AdminNavbar from '../../Components/Navbar/AdminNavbar';
import { postData, getData } from '../../Services/api';

// Styles
import 'react-date-range/dist/theme/default.css';
import 'react-date-range/dist/styles.css';
import './styleRange.css';

const Dashboard = () => {

    const [dateInitial, setDateInitial] = useState([{ startDate: new Date(), endDate: new Date(), key: 'selection', }]);
    const [loadingButtons, setLoadingButtons] = useState({});
    const [updatePage, setUpdatePage] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [countLeads, setcountLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const navigate = useNavigate();

    const token = localStorage.getItem('token');

    useEffect(() => {
        if (token) {
            const extractCountLeads = async () => {
                const counts = await getData('allLeads');
                setcountLeads(counts?.data);
            }

            const extractLeads = async () => {
                const leads = await getData('leadsToday');
                setData(leads?.data?.DATA);
            }

            setLoading(false);
            extractCountLeads();
            extractLeads();
        } else {
            navigate('/Login');
        }
    }, [updatePage]);

    const columns = useMemo(
        () => [
            {
                Header: 'ID',
                accessor: 'id',
            },
            {
                Header: 'Nombre Completo',
                accessor: 'name',
            },
            {
                Header: 'Telefono',
                accessor: 'number',
            },
            {
                Header: 'Origen',
                accessor: 'origen',
            },
            {
                Header: 'Tipo de Formulario',
                accessor: 'plan',
            },
            {
                Header: 'Id lead',
                accessor: 'id_lead',
            },
            {
                Header: 'Gclid',
                accessor: 'gclid',
            },
            {
                Header: 'Grupo de anuncio',
                accessor: 'anuncioGroup',
            },
            {
                Header: 'Campaignid',
                accessor: 'campaignid',
            },
            {
                Header: 'Adgroupid',
                accessor: 'adgroupid',
            },
            {
                Header: 'Keyword',
                accessor: 'keyword',
            },
            {
                Header: 'AdId',
                accessor: 'adId',
            },
            {
                Header: 'Fecha Creación',
                accessor: 'fecha',
            }
        ],
        []
    );

    const keywords = ['error', 'Primera inserción', 'score', '{}'];

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setGlobalFilter,
        state: { globalFilter }
    } = useTable({ columns, data }, useGlobalFilter);

    const formatDate = (current_datetime) => {
        let formatted_date = current_datetime.getFullYear() + "-"
            + ((current_datetime.getMonth() < 9 ? '0' : '') + (current_datetime.getMonth() + 1)) + "-"
            + ((current_datetime.getDate() < 9 ? '0' : '') + (current_datetime.getDate()))
        return formatted_date;
    }

    const handleExport = async () => {
        const dateStartTime = formatDate(dateInitial[0].startDate);
        const dateEndTime = formatDate(dateInitial[0].endDate);

        try {
            const ExtractGrupsForDate = await postData('filter', {
                fechaInicio: dateStartTime,
                fechaFin: dateEndTime
            });

            if (ExtractGrupsForDate?.OK === true) {
                setData(ExtractGrupsForDate.DATA);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: `Ocurrio un error al traer la data!`
                })
            }

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: `Ocurrio un error! - ${error}`
            });
        }
        onClose();
    }

    const handleDownloadData = () => {
        ExportDataRange({ apiData: data, fileName: `Export Leads Digicel` });
    }

    const extractSales = async (endPoint) => {
        const extract = await getData(endPoint);
        ExportDataRange({ apiData: extract?.data?.DATA, fileName: `Export Leads Digicel` })
    }

    const insertRetry = async (id) => {
        setLoadingButtons(prev => ({ ...prev, [id]: true }));

        const submitBitrix = await postData('retryBitrix', { id });

        if (submitBitrix?.OK === true) {
            Swal.fire({
                icon: 'success',
                title: 'Insertado en Bitrix',
                text: `ID Lead: ${submitBitrix.id_lead}`,
                timerProgressBar: true,
                timer: 5000,
                showConfirmButton: true
            })
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Error al insertar en Bitrix',
                text: submitBitrix?.ERROR || submitBitrix?.MESSAGERESPONSE,
                timerProgressBar: true,
                timer: 5000,
                showConfirmButton: true
            })
        }

        setLoadingButtons(prev => ({ ...prev, [id]: false }));
        setUpdatePage(prev => !prev);
    };


    return (
        <>
            {
                !loading
                &&
                <>
                    {/* Navbar */}
                    <AdminNavbar />

                    {/* Targets */}
                    <Flex w="80%" m="auto" my="10" flexDirection={{ base: "column", sm: "column", md: "column", lg: "row" }}>
                        <Box bg="#E4002B" borderRadius='20' py="5" px="8">
                            <HStack spacing='10px'>
                                <RiHistoryLine size="30px" color="white" />
                                <Button onClick={() => extractSales('leadsHistory')} className="Title" color="white" variant="link" fontSize="2xl">HISTORICO: {countLeads?.History}</Button>
                            </HStack>
                        </Box>
                        <Spacer />
                        <Box bg="#E4002B" borderRadius='20' py="5" px="8" mt={{ base: "5", md: "0" }}>
                            <HStack spacing='10px'>
                                <BsCalendar3 size="30px" color="white" />
                                <Button onClick={() => extractSales('leadsMonth')} className="Title" color="white" variant="link" fontSize="2xl">MES: {countLeads?.Mes}</Button>
                            </HStack>
                        </Box>
                        <Spacer />
                        <Box bg="#E4002B" borderRadius='20' py="5" px="8" mt={{ base: "5", md: "0" }}>
                            <HStack spacing='10px'>
                                <WiDayCloudy size="30px" color="white" />
                                <Button onClick={() => extractSales('leadsToday')} className="Title" color="white" variant="link" fontSize="2xl">DÍA: {countLeads?.Dia}</Button>
                            </HStack>
                        </Box>
                    </Flex>

                    {/* Table */}
                    <Box my="10" mx="auto" w="80%">
                        <Flex>
                            <Tooltip hasArrow label='Filtrar por fecha'>
                                <Button onClick={onOpen} mr="5">
                                    <IoCalendarOutline />
                                </Button>
                            </Tooltip>

                            <Tooltip hasArrow label='Descargar'>
                                <Button onClick={handleDownloadData}>
                                    <FiDownload />
                                </Button>
                            </Tooltip>
                        </Flex>

                        <TableContainer {...getTableProps()} mt="6">
                            <Table size='sm'>
                                <Thead>
                                    {
                                        headerGroups.map(headerGroup => (
                                            <Tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                                                <Th>
                                                    Insert Bitrix
                                                </Th>
                                                {
                                                    headerGroup.headers.map(column => (
                                                        <Th style={{ width: "150px", maxWidth: '150px' }} {...column.getHeaderProps()} key={column.id}>
                                                            {
                                                                column.render('Header')
                                                            }
                                                        </Th>
                                                    ))
                                                }
                                            </Tr>
                                        ))
                                    }
                                </Thead>
                                <Tbody {...getTableBodyProps()}>
                                    {
                                        rows.map(row => {
                                            prepareRow(row);

                                            return (
                                                <Tr {...row.getRowProps()} key={row.id}>
                                                    <Td>
                                                        {row?.original?.error && <Tooltip hasArrow label="Insertar">
                                                            <IconButton icon={<BsSendArrowUp />} isLoading={loadingButtons[row?.original?.id]} bg='#E4002B' color='white' border='2px solid #E4002B' _hover={{ color: '#E4002B', bg: 'transparent' }} onClick={() => insertRetry(row?.original?.id)} />
                                                        </Tooltip>}
                                                    </Td>
                                                    {
                                                        row.cells.map((cell, i) => {
                                                            return (
                                                                <Td style={{ maxWidth: '300px' }} whiteSpace="normal" overflow='hidden' textOverflow='ellipsis' {...cell.getCellProps()} key={i}>
                                                                    {
                                                                        cell.render('Cell')
                                                                    }
                                                                </Td>
                                                            )
                                                        })
                                                    }
                                                </Tr>
                                            )
                                        })
                                    }
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* Modal filter Leads */}
                    <Modal
                        isCentered
                        onClose={onClose}
                        isOpen={isOpen}
                        motionPreset='slideInBottom'
                        size={'xl'}
                    >
                        <ModalOverlay />

                        <ModalContent>
                            <ModalHeader><Center>FILTRAR POR RANGO DE FECHAS</Center></ModalHeader>

                            <ModalCloseButton />

                            <ModalBody>
                                <DateRangePicker
                                    className="range-date"
                                    showSelectionPreview={true}
                                    moveRangeOnFirstSelection={false}
                                    ranges={dateInitial}
                                    onChange={item => setDateInitial([item.selection])}
                                    locale={locales['es']}
                                />
                            </ModalBody>

                            <ModalFooter>
                                <Button colorScheme='blue' variant='outline' mr={3} onClick={onClose}>
                                    Cancelar
                                </Button>
                                <Button leftIcon={<FiDownload />} colorScheme='green' variant='outline' onClick={handleExport}>FILTRAR</Button>
                            </ModalFooter>
                        </ModalContent>
                    </Modal>
                </>
            }
        </>
    )
};

export default Dashboard;